module.exports = __webpack_public_path__ + "img/Search.5199f290.svg";